// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { DateField, DateFieldProps } from 'react-admin';

export const UTC_OPTIONS_WITHOUT_DISPLAY = { timeZone: 'UTC' } as const;

/**
 * Intl.DateTimeFormat options to use UTC timezone and display UTC after date time
 */
export const UTC_OPTIONS = { ...UTC_OPTIONS_WITHOUT_DISPLAY, timeZoneName: 'short' } as const;

/**
 * wrapper around `DateField` from react-admin that displays the time in **UTC**
 */
export const UTCDateField = ({
  'data-testid': testId,
  ...props
}: DateFieldProps & { 'data-testid'?: string }) => (
  <DateField
    data-testid={testId}
    {...props}
    options={{
      ...props.options,
      ...(props.showTime ? UTC_OPTIONS : UTC_OPTIONS_WITHOUT_DISPLAY),
    }}
  />
);
